export default [
  { to: 'behandlingsriktlinjer_vuxen', title: 'Behandlingsriktlinjer Vuxen' },
  { to: 'behandlingsriktlinjer_barn', title: 'Behandlingsriktlinjer Barn' },
  { to: 'lakemedel', title: 'Läkemedel' },
];
